import { render, staticRenderFns } from "./BlogAdd.vue?vue&type=template&id=16072b7c&"
import script from "./BlogAdd.vue?vue&type=script&lang=js&"
export * from "./BlogAdd.vue?vue&type=script&lang=js&"
import style0 from "./BlogAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports